import axios, { AxiosError } from "axios";
import { useState, useCallback } from "react";

const DEFAULT_URL: string | undefined = import.meta.env.DEV
  ? import.meta.env.VITE_AJAX_URL
  : ajaxCharter.ajaxUrl;

if (!DEFAULT_URL) {
  throw Error("Missing AJAX_URL.");
}

const useAjax = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const request = useCallback(
    async <T>(
      actionName: string,
      params: Record<string, unknown> = {},
      url = DEFAULT_URL,
      searchParams: Record<string, string> | undefined = undefined
    ): Promise<Awaited<T> | null> => {
      setError(null);
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("action", actionName);
        Object.keys(params).forEach((key) => {
          formData.append(key, String(params[key]));
        });
        const urlObject = new URL(url);
        if (searchParams) {
          Object.keys(searchParams).forEach((key) => {
            const val = searchParams[key];
            urlObject.searchParams.append(key, val);
          });
        }
        const response = await axios.post(urlObject.toString(), formData);
        setLoading(false);
        return response.data;
      } catch (e) {
        setLoading(false);
        if (e instanceof AxiosError) {
          setError(e.response?.data || "Chyba volání API");
        } else if (e instanceof Error) {
          setError(e.message);
        } else if (typeof e === "string") {
          setError(e);
        } else {
          setError("Chyba volání API");
        }
      }
      return null;
    },
    []
  );

  const clearError = useCallback(() => setError(null), []);

  return { loading, request, error, clearError };
};

export default useAjax;
